// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lll3","toggleWrap":"styles_toggleWrap__1uK1W","content":"styles_content__2zBzI","selectAreaCode":"styles_selectAreaCode__335Ji"};